<template>
    <a-modal :open="open" title="简易复制" width="70%" :footer="null" destroy-on-close :maskClosable="false"
        @cancel="handleCancel">
        <a-spin :spinning="state.loading" :tip="state.tip">
            <div class="simple-copy-body">
                <a-form ref="formRef" :model="formState" :rules="rules" :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }">
                    <!-- 6个单选，一行3个 -->
                    <a-row :gutter="16">
                        <a-col :span="9">
                            <a-form-item label="主体类型" required>
                                <a-radio-group v-model:value="formState.main_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">公司</a-radio-button>
                                    <a-radio-button :value="2">个体户</a-radio-button>
                                    <a-radio-button :value="3">个独</a-radio-button>
                                    <a-radio-button :value="4">合伙</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="7">
                            <a-form-item label="收费标准" required>
                                <a-radio-group v-model:value="formState.fee_standard" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">按年收费</a-radio-button>
                                    <a-radio-button :value="2">一次性收费</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="税务身份" required>
                                <a-radio-group v-model:value="formState.is_ybr" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="2">小规模纳税人</a-radio-button>
                                    <a-radio-button :value="1">一般纳税人</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="16">
                        <a-col :span="9">
                            <a-form-item label="业务类型" required>
                                <a-radio-group v-model:value="formState.business_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">设立</a-radio-button>
                                    <a-radio-button :value="2">同区迁入</a-radio-button>
                                    <a-radio-button :value="3">跨区迁入</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="7">
                            <a-form-item label="注册类型" required>
                                <a-radio-group v-model:value="formState.registration_type" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="1">包注册</a-radio-button>
                                    <a-radio-button :value="2">出裸地址</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="分支机构" required>
                                <a-radio-group v-model:value="formState.is_filiale" button-style="solid"
                                    class="radio-group radio-group-auto">
                                    <a-radio-button :value="2">否</a-radio-button>
                                    <a-radio-button :value="1">是</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 是否可录单 -->
                    <a-form-item
                        v-if="!((formState.main_type == 1 || formState.main_type == 3) && formState.business_type == 1)"
                        name="is_auto" label="是否可录单">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_auto"
                            checked-children="资料已确定，资料员可以录单了" un-checked-children="还有资料未确定，资料员不要录单" />
                    </a-form-item>
                    <a-form-item label="平台对接人手机号(选填)" name="platform_person_mobile">
                        <a-input v-model:value="formState.platform_person_mobile" placeholder="请输入平台对接人手机号"></a-input>
                    </a-form-item>
                    <a-form-item label="平台对接人微信号或其他(选填)" name="platform_wechat_account">
                        <a-input v-model:value="formState.platform_wechat_account" placeholder="请输入平台对接人微信号"></a-input>
                    </a-form-item>
                    <!-- 待注册主体名称 -->
                    <a-form-item name="entityNameToRegister" required label="待注册主体名称">
                        <principal-name ref="principalName" :business_type="formState.business_type"
                            :principalType="formState.main_type" :isFiliale="formState.is_filiale" :push_system="1"
                            :is_heming="2" v-model:value="formState.entityNameToRegister" />
                        <a-divider type="vertical" v-if="formState.business_type != 1" />
                        <a-button v-if="formState.business_type == 1" @click="getrandcompanyname" type="primary"
                            :icon="h(DeploymentUnitOutlined)">获取字号</a-button>
                        <div v-if="state.companyName.length > 0" class="mt-1x">
                            <a-tag class="mr-1x mb-1x pointer" color="success" @click="selectCompanyNameChange(item)"
                                v-for="(item, index) in state.companyName" :key="index">{{ item }}</a-tag>
                        </div>
                    </a-form-item>

                    <!-- 注册详细地址 -->
                    <a-form-item name="registration_address" label="注册详细地址">
                        <a-input placeholder="请输入注册详细地址（选填）" v-model:value="formState.registration_address" />
                    </a-form-item>

                    <!-- 工商预留手机号码 -->
                    <a-form-item label="工商预留手机号码" name="registration_mobile" required>
                        <a-input @change="(v) => { phoneOrLandlineChange(v, 'registration_mobile') }"
                            :value="formState.registration_mobile" placeholder="请输入工商预留手机号码">
                            <template #suffix>
                                <a-tooltip title="此手机号码将提交给工商局,会有很多广告电话打进来,请谨慎留取">
                                    <InfoCircleOutlined style="color: rgba(0, 0, 0, 0.45)" />
                                </a-tooltip>
                            </template>
                        </a-input>
                    </a-form-item>

                    <!-- 代理商花名 -->
                    <a-form-item label="代理商花名" name="seller" required>
                        <a-input v-model:value="formState.seller" placeholder="请输入代理商花名" />
                    </a-form-item>

                    <!-- 续费联系人手机号码 -->
                    <a-form-item label="续费联系人手机号码" name="xftel">
                        <a-input @change="(v) => { phoneChange(v, 'xftel') }" v-model:value="formState.xftel"
                            placeholder="请输入续费联系人手机号码" />
                    </a-form-item>

                    <!-- 代理商注册拿货价格 + 代理商来年续费价格 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item :label="'代理商【' + (formState.seller || '资料员') + '】注册价格'" name="dls_bzc_price"
                                :labelCol="{ span: 12 }" :wrapperCol="{ span: 8 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.dls_bzc_price"
                                    placeholder="请输入代理商注册价格" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item v-if="formState.fee_standard === 1" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 12 }" :label="'代理商【' + (formState.seller || '资料员') + '】来年续费价格'"
                                name="dls_xf_price">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.dls_xf_price"
                                    placeholder="请输入代理商来年续费价格" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 给续费联系人注册价 + 给续费联系人续费价 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="给续费联系人注册价" name="xflxr_zc_price" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 8 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.xflxr_zc_price"
                                    placeholder="请输入给续费联系人注册价" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item v-if="formState.fee_standard === 1" label="给续费联系人续费价" name="xflxr_xf_price"
                                :labelCol="{ span: 12 }" :wrapperCol="{ span: 12 }">
                                <a-input type="number" prefix="￥" suffix="元" v-model:value="formState.xflxr_xf_price"
                                    placeholder="请输入给续费联系人续费价" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 微信服务群 + 备注 同一行 -->
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="微信服务群（优先反馈）" name="weixinqun" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 8 }">
                                <a-input v-model:value="formState.weixinqun" placeholder="请输入客户服务群" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="备注(保密,仅自己可见)" name="remark" :labelCol="{ span: 12 }"
                                :wrapperCol="{ span: 12 }">
                                <a-input v-model:value="formState.remark" placeholder="请输入备注" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- 提交按钮放在底部 -->
                    <div class="form-footer">
                        <a-button style="margin-right: 8px" @click="handleCancel">取消</a-button>
                        <a-button type="primary" size="large" :loading="state.confirmLoading" @click="onFormSubmit">
                            提交保存
                        </a-button>
                    </div>
                </a-form>
            </div>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup>
import baseService from '@/utils/http/axios'
import { InfoCircleOutlined, DeploymentUnitOutlined } from '@ant-design/icons-vue'
import PrincipalName from './components/form/PrincipalName.vue'
import { reactive, onMounted, ref, h, watch } from 'vue'
import { message } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import dayjs from 'dayjs'
import { mobileOrLandlineRequiredValidator } from '@/utils/util'
import ls from '@/utils/Storage'

const UserInfo = ls.get('USER_INFO')

const props = defineProps<{
    open: boolean
    record: any
}>()

const emit = defineEmits(['ok', 'cancel'])

const formRef = ref()
const principalName = ref()

interface FormState {
    main_type: number
    business_type: number
    is_ybr: number
    is_filiale: number
    registration_type: number
    is_auto: number
    dls_bzc_price: number | null
    dls_xf_price: number | null
    entityNameToRegister: any
    registration_address: string | null
    registration_mobile: string
    fee_standard: number
    seller: string
    xflxr_zc_price: number | null
    xflxr_xf_price: number | null
    xftel: string
    weixinqun: string
    remark: string | null
    upload_path: string
    platform_wechat_account: string
    platform_person_mobile: string
}

const getDefaultFormState = (): FormState => ({
    main_type: 1,
    business_type: 1,
    is_ybr: 2,
    is_filiale: 2,
    registration_type: 1,
    is_auto: 1,
    dls_bzc_price: 200,
    dls_xf_price: 200,
    entityNameToRegister: { name_division: '' },
    registration_address: null,
    registration_mobile: '',
    fee_standard: 1,
    seller: UserInfo?.nickname || '',
    xflxr_zc_price: 300,
    xflxr_xf_price: 300,
    xftel: '',
    weixinqun: '',
    remark: null,
    upload_path: '',
    platform_wechat_account: '',
    platform_person_mobile: '',
})

const formState = reactive<FormState>(getDefaultFormState())

interface State {
    loading: boolean
    tip: string
    confirmLoading: boolean
    uploadPathObj: any
    companyName: string
}

const state = reactive<State>({
    loading: false,
    tip: '加载中...',
    confirmLoading: false,
    uploadPathObj: {
        date: dayjs().format('YYYYMM'),
        platformCompanyName: '独立注册',
        companyName: '',
        mainTypeName: '公司'
    },
    companyName: ''
})

// 校验规则
const checkEntityNameToRegister = (rule: any, value: any) => {
    if (!value) return Promise.reject('请填写主体名称')
    if (!value.organizational_form) return Promise.reject('请输入组织形式')
    if (formState.is_filiale == 1) {
        if (!value.filiale_full_name) return Promise.reject('请输入总公司名称')
        if (!value.name_word_mark && value.no_word != 1) return Promise.reject('请输入字号')
    } else {
        if (!value.name_division) return Promise.reject('请输入名称区划')
        if (!value.name_word_mark) return Promise.reject('请输入字号')
        if (!value.ondustry_representation) return Promise.reject('请输入行业表述')
    }
    return Promise.resolve()
}

const rules: Record<string, Rule[]> = {
    entityNameToRegister: [{ validator: checkEntityNameToRegister }],
    registration_mobile: [{ required: true, validator: mobileOrLandlineRequiredValidator }]
}

// 监听主体类型变化
watch(
    () => formState.main_type,
    (val) => {
        const typeMap: any = { 1: '公司', 2: '个体户', 3: '个人独资企业', 4: '合伙企业' }
        state.uploadPathObj.mainTypeName = typeMap[val] || '公司'
    },
    { immediate: true }
)

// 监听主体名称变化
watch(
    () => formState.entityNameToRegister?.full_name,
    (val) => {
        if (val) state.uploadPathObj.companyName = val
    }
)

// 电话验证
const phoneChange = (v: any, type: string) => {
    if (v.target.value) {
        const str = v.target.value.replace(/\D/g, '')
        if (/^1[23456789]\d{9}$/.test(str)) {
            formState[type as keyof FormState] = str as any
        }
    }
}

const phoneOrLandlineChange = (v: any, type: string) => {
    if (v.target.value) {
        const str = v.target.value.replace(/\D/g, '')
        if (/^1[23456789]\d{9}$/.test(str) || /^0\d{2,3}-?\d{7,8}$/.test(str)) {
            formState[type as keyof FormState] = str as any
        }
    }
}

// 重置
const resetForm = () => {
    const defaults = getDefaultFormState()
    Object.keys(defaults).forEach(key => {
        (formState as any)[key] = (defaults as any)[key]
    })
    formRef.value?.clearValidate()
}

/**
 * ✅ 用 record 回填（基础字段）
 */
const fillBaseForm = (record: any) => {
    if (!record) return

    formState.main_type = record.main_type ?? 1
    formState.business_type = record.business_type ?? 1
    formState.is_ybr = record.is_ybr ?? 2
    formState.is_filiale = record.is_filiale ?? 2
    formState.registration_type = record.registration_type ?? 1
    formState.is_auto = record.is_auto ?? 1
    formState.dls_bzc_price = record.dls_bzc_price ?? 200
    formState.dls_xf_price = record.dls_xf_price ?? 200
    formState.registration_address = record.registration_address ?? null
    formState.registration_mobile = record.registration_mobile ?? ''
    formState.fee_standard = record.fee_standard ?? 1
    formState.seller = record.seller ?? UserInfo?.nickname ?? ''
    formState.xflxr_zc_price = record.xflxr_zc_price ?? 300
    formState.xflxr_xf_price = record.xflxr_xf_price ?? 300
    formState.xftel = record.xftel ?? ''
    formState.weixinqun = record.weixinqun ?? ''
    formState.remark = record.remark ?? null
    formState.platform_wechat_account = record.platform_wechat_account ?? ''
    formState.platform_person_mobile = record.platform_person_mobile ?? ''
}

/**
 * ✅ 拉详情 + 回填主体名称
 */
const fetchDetailAndFillName = async (record: any) => {
    if (!record || !record.id) return

    state.loading = true
    state.tip = '加载主体信息...'

    try {
        const res: any = await baseService({
            url: `/admin/v1/customer/${record.id}/edit`,   // ✅ 正确的路径
            method: 'get'
        })

        const detail = res?.data || {}
        const nameData = detail.entityNameToRegister || {}

        formState.entityNameToRegister = {
            name_division: nameData.name_division || '',
            filiale_full_name: nameData.filiale_full_name || '',
            name_word_mark: nameData.name_word_mark || '',
            ondustry_representation: nameData.ondustry_representation || '',
            ondustry_representation_type: nameData.ondustry_representation_type ?? null,
            ondustry_representation_id: nameData.ondustry_representation_id ?? null,
            ondustry_representation_four: nameData.ondustry_representation_four || '',
            organizational_form: nameData.organizational_form || '',
            name_division_position: nameData.name_division_position ?? 0,
            no_postfix: nameData.no_postfix ?? 2,
            no_word: nameData.no_word ?? 2,
            full_name: nameData.full_name || detail.full_name || record.full_name || ''
        }

        if (detail.full_name) {
            state.uploadPathObj.companyName = detail.full_name
        }
    } catch (e: any) {
        console.warn('获取详情失败，主体名称需手动填写', e)
        message.warning('主体名称自动回填失败，请手动填写')
        formState.entityNameToRegister = {
            name_division: '',
            filiale_full_name: '',
            name_word_mark: '',
            ondustry_representation: '',
            ondustry_representation_type: null,
            ondustry_representation_id: null,
            ondustry_representation_four: '',
            organizational_form: '',
            name_division_position: 0,
            no_postfix: 2,
            no_word: 2,
            full_name: record.full_name || ''
        }
    } finally {
        state.loading = false
    }
}

// 初始化
const initForm = async (record: any) => {
    if (!record) return
    resetForm()
    fillBaseForm(record)
    await fetchDetailAndFillName(record)
}

watch(
    () => props.open,
    async (val) => {
        if (val) {
            await initForm(props.record)
        }
    },
    { immediate: true }
)

// ✅ 兜底：record 后到也处理
watch(
    () => props.record,
    async (val) => {
        if (props.open && val && val.id) {
            await initForm(val)
        }
    },
    { deep: true }
)

// 提交
const onFormSubmit = () => {
    formRef.value?.validate().then(() => {
        formState.upload_path = `public/uploads/注册/${state.uploadPathObj.platformCompanyName}/客户资料/${state.uploadPathObj.mainTypeName}/${state.uploadPathObj.date}/${state.uploadPathObj.companyName}/`

        state.confirmLoading = true

        baseService({
            url: '/admin/v1/customer/simpleStore',
            method: 'post',
            data: formState
        })
            .then((res: any) => {
                state.confirmLoading = false
                if (res.code === 0) {
                    message.success(res.msg || '提交成功')
                    emit('ok')
                } else {
                    message.warning(res.msg || '提交失败')
                }
            })
            .catch((err: any) => {
                state.confirmLoading = false
                if (err?.data?.code === 0 || err?.code === 0) {
                    message.success(err?.data?.msg || err?.msg || '提交成功')
                    emit('ok')
                    return
                }
                const errMsg = err?.msg || err?.data?.msg || err?.message || '提交失败，请稍后重试'
                message.warning(errMsg)
            })
    }).catch(() => { })
}

const handleCancel = () => {
    emit('cancel')
}

// 获取字号
const getrandcompanyname = () => {
    let requestParam = {
        url: '/admin/v1/getrandcompanyname?num=26',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            state.companyName = res.data.msg
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}

const selectCompanyNameChange = (val) => {
    principalName.value.inputChange(
        {
            target: {
                value: val
            }
        },
        'name_word_mark'
    )
}

onMounted(() => {
    if (!formState.seller) {
        formState.seller = UserInfo?.nickname || ''
    }
})
</script>

<style lang="less" scoped>
.simple-copy-body {
    :deep(.ant-form-item) {
        margin-bottom: 24px;

        .ant-form-item-label {
            text-align: right;
            padding-right: 12px;
            font-weight: 500;
            line-height: 32px;
        }

        .ant-form-item-control-input {
            min-height: 32px;
        }
    }

    .radio-group-auto {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;

        .ant-radio-button-wrapper {
            flex: 0 0 auto;
            text-align: center;
            padding: 0 16px;
            white-space: nowrap;
        }
    }

    .form-footer {
        display: flex;
        justify-content: center;
        padding: 20px 0 10px 0;
        border-top: 1px solid #f0f0f0;
        margin-top: 10px;

        .ant-btn {
            min-width: 120px;
        }
    }
}
</style>
